import React from "react";
import about1 from "../assets/about/about1.webp";
import goals from "../assets/about/goals.png";
import bgImg from "../assets/about/bg-img.png";
import About from "../assets/about/AboutUs.png";
import { Navbar } from "../Component/Navbar";
import Newsletter from "../Component/Home/Newsletter";
import { Footer } from "../Component/Footer";

export default function AboutUs() {
  return (
    <>
      <Navbar />
      <div className="mt-0">
        <div className="min-h-screen bg-white">
          {/* Hero Section with Background - Fixed */}
          <div className="relative overflow-hidden px-5 mb-16">
            {/* Image and overlay in same container */}
            <div
              className="absolute inset-0 bg-cover h-[50rem] md:h-full bg-center opacity-50"
              style={{
                backgroundImage: `url(${about1})`,
              }}
            />

            {/* Purple Overlay with Content */}
            <div className="relative z-10  bg-purple-950 bg-opacity-80 px-5 py-5 lg:px-20 lg:py-28 w-full lg:max-w-[75vw] mx-auto text-white text-center">
              <h1 className="text-4xl font-bold mb-6">About Us</h1>
              <p className="text-lg leading-relaxed max-w-4xl mx-auto">
                SilverTLC is a customer service relations management tool to
                assist government; national insurance/managed care
                organizations; non-profits; hospital/health care systems; as
                well as local, state, national, and federal agencies...
              </p>
            </div>
          </div>

          {/* Rest of your component remains unchanged */}
          {/* mission and why */}
          <div className="relative">
            {/* Background Image */}
            <div
              className="absolute inset-0 bg-cover bg-center opacity-30 ml-20"
              style={{
                backgroundImage: `url(${bgImg})`,
                backgroundSize: "60vw",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "left",
              }}
            ></div>

            {/* Content */}
            <div className="relative z-10">
              {/* Mission Section */}
              <div className="w-full lg:max-w-[81vw] mx-auto px-6 mb-16">
                <h2 className="text-3xl font-bold text-purple-600 text-center mb-8">
                  The SilverTLC Mission Is To:
                </h2>
                <div className="space-y-6 bg-[#F9F5F2] bg-opacity-70 p-8 rounded-lg">
                  <p className="leading-relaxed">
                    • Recruit, maintain, and expand relationships with service
                    organizations and companies including, but not limited to,
                    transportation, physical therapists, mental health
                    clinics/therapists, adult day care, specialized nursing and
                    home health care, moving services, construction service
                    companies to provide specific and routine needs for our
                    senior and disabled clients;
                  </p>
                  <p className="leading-relaxed">
                    • Develop and manage a customer relations management
                    website, as well as, mobile android and ios applications.
                  </p>
                </div>
              </div>

              {/* Why Section */}
              <div className="w-full lg:max-w-[81vw] mx-auto px-6 py-5 mb-16">
                <h2 className="text-3xl font-bold text-purple-600 text-center mb-8">
                  Our Why:
                </h2>
                <div className="space-y-6 bg-[#F9F5F2] bg-opacity-70 p-10 rounded-lg">
                  <p className="leading-relaxed">
                    Housing has become expensive and in short supply. Even more
                    so for senior and disabled populaces. When we include those
                    in poverty, the options become fewer. Entities from
                    government agencies to for-profit companies to non-profit
                    organizations are working to resolve housing needs for these
                    markets as it pertains to their effectiveness, efficiency,
                    and profitability while also offering services that
                    adequately meet the needs of these populations.
                  </p>
                  <div className="space-y-5">
                    <p className="font-semibold">How SilverTLC will help.</p>
                    <p className="leading-relaxed">
                      SilverTLC will provide the following services to assist
                      partners with placing and maintaining those in their care
                      by;
                    </p>
                    <ul className="list-disc pl-6 space-y-6">
                      <li>
                        Locating properties fitting the needs of the senior and
                        disabled populaces we serve;
                      </li>
                      <li>
                        Negotiating lease agreements with property management
                        companies and property owners. In some proprietary
                        agreements, SilverTLC will hold the lease and make space
                        available to our partners and their clients
                      </li>
                      <li>
                        Purchasing, delivering, and setting up furniture (as
                        needed)
                      </li>
                      <li>
                        Acting as a liaison when necessary between agency,
                        service providers, and senior and disabled clients;
                        property owners/management; and any other service
                        provider providing services directly to secondary client
                        populations or at their provided residences
                      </li>
                      <li>
                        Conducting initial property inspections. Administering
                        minor modifications and final inspections of
                        single-family dwellings and multi-family properties, as
                        well as apartment complexes (when requested)
                      </li>
                      <li>
                        Develop and manage online dashboard and mobile IOS and
                        android applications to search and secure properties and
                        services
                      </li>
                      <li>
                        Provide a centralized portal for those servicing senior
                        and disabled populations to collaborate and develop
                        resources for the future
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* goals Section */}
          <div className="max-w-4xl mx-auto px-6 mb-16">
            <h2 className="text-3xl font-bold text-purple-600 text-center mb-8">
              Our Goals:
            </h2>

            {/* circular wheel design */}
            <div>
              <img alt="about" src={About} className="w-full" />
            </div>
          </div>
        </div>
      </div>

      {/* newsletter & footer */}
      <Newsletter />
      <Footer />
    </>
  );
}
